function initFeaturedFaqFilters() {
  const filterButtons = document.querySelectorAll('.featured-faq__filter');
  const faqElements = document.querySelectorAll('.accordion--faq');

  initEvents(filterButtons, faqElements);
}

function initEvents(filterButtons, faqElements) {
  filterButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const activeCategory = button.value;

      if(activeCategory) {
        setFilterActiveState(activeCategory, filterButtons);
        filterFaqs(activeCategory, faqElements);
      }
    });
  });
}

function setFilterActiveState(activeCategory, filterButtons) {
  filterButtons.forEach(button => {
    button.classList.remove('active');
    if(activeCategory === button.value) {
      button.classList.add('active');
    }
  });
}

function filterFaqs(activeCategory, faqElements) {
  faqElements.forEach(faq => {
    faq.classList.add('hidden');
    if(activeCategory === faq.dataset.category) {
      faq.classList.remove('hidden');
    }
  });
}

window.onload = initFeaturedFaqFilters();
